import { render } from "./PostsPlatformToolbar.vue?vue&type=template&id=0164d124&ts=true"
import script from "./PostsPlatformToolbar.vue?vue&type=script&lang=ts"
export * from "./PostsPlatformToolbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__